import useDesignSystemStore from "@/store/zustand/aiDesignSystemBuilder";
import React from "react";

const PropsViewer = () => {
  const props = useDesignSystemStore((state) => state.generation.context.props);

  return (
    <div className="flex flex-row gap-1 flex-wrap">
      {props.map((prop: any, index) => {
        const isString = typeof prop === "string";

        if (!isString) {
          return null;
        }

        return (
          <div className="flex flex-col gap-1" key={index}>
            <div className="font-bold px-1 py-0.5 bg-primary-0 text-3xs rounded-md">
              {prop}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(PropsViewer);
